// Mobile sticky bar – show on scroll down, hide on scroll up
(function () {
  // prevenim dublarea inițializării
  if (window.MobileStickyBarInit) return;
  window.MobileStickyBarInit = true;

  // dacă tema ta are deja debounce global, îl folosim. Dacă nu, folosim fallback:
  const debounceFn =
    typeof debounce === 'function'
      ? debounce
      : (func, wait) => {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        };

  document.addEventListener('DOMContentLoaded', function () {
    const bar = document.querySelector('.mobile-sticky-bar');
    if (!bar) return;

    let lastScrollTop = window.scrollY;
    const threshold = 5; // mic filtru ca să nu reacționeze la vibrații mici de scroll

    const onScroll = () => {
      const st = window.scrollY;

      // dacă aproape nu s-a mișcat, nu facem nimic
      if (Math.abs(st - lastScrollTop) <= threshold) return;

      // la începutul paginii, ascundem bara
      if (st <= 0) {
        bar.classList.remove('msb-show');
        bar.classList.add('msb-hide');
        lastScrollTop = st;
        return;
      }

      if (st > lastScrollTop) {
        // 👉 Scroll DOWN – AFIȘEAZĂ bara
        bar.classList.add('msb-show');
        bar.classList.remove('msb-hide');
      } else {
        // 👉 Scroll UP – ASCUNDE bara
        bar.classList.add('msb-hide');
        bar.classList.remove('msb-show');
      }

      lastScrollTop = st;
    };

    window.addEventListener('scroll', debounceFn(onScroll, 10), { passive: true });
  });
})();
